import axios from 'axios';

import type { BuildJsonType } from '@bb/domain/dist/typeHelpers';
import type { Covid19Settings } from '@bb/domain/dist/types';

export type GetCovid19ListingSettingsResponse = BuildJsonType<Covid19Settings>;

const getCovid19ListingSettings = async (listingId: string) => {
  const { data: covid19Settings } =
    await axios.get<GetCovid19ListingSettingsResponse>(
      `/covid19/listing/${listingId}/settings`,
    );

  return covid19Settings;
};

export default getCovid19ListingSettings;
